// nav-tree
// show hierarchy of nodes in side pane

import React, { useState } from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
// import { toJS } from 'mobx'
import { observer } from "mobx-react-lite"
import fileDownload from 'js-file-download'
import {
  GoFile,
  GoLinkExternal,
  GoX,
  GoCloudDownload,
  GoFileDirectory,
  GoPencil,
  GoChevronLeft,
  GoChevronRight,
  GoCheck,
  GoPlus,
  GoTerminal,
  GoTrashcan,
  GoChevronDown,
  GoChevronUp,
} from "react-icons/go"
import { FaHome } from 'react-icons/fa'
import { IoMdArrowBack } from 'react-icons/io'
import { IoMdArrowForward } from 'react-icons/io'
import './styles.css'
import DialogText from '../../packages/dialog-text'
// import NavMenu from './nav-menu'
import PopupMenu from './popup-menu'
import { useNeomem } from '../application'
// import { useForceRefresh } from '../../util'
import iconHome from '../../assets/images/home.svg'
import iconFlag from '../../assets/images/flag.svg'
import iconFlags from '../../assets/images/flags3.svg'
import iconLeft from '../../assets/images/indent-left.png'
import iconRight from '../../assets/images/indent-right.png'
import flags from '../../flags'
import * as util from './util'
import iconMenu from './images/menu.svg'


const typeIcons = {
  // home: <img src={home} alt=""/>,
  // trip: <img src={flags} alt="" />,
  // place: <img src={flag} alt=""/>,
}

// maps actionIds to icons
const actionIcons = {
  addFolder: <GoFileDirectory />,
  addTrip: <img src={iconFlags} alt="" />,
  deleteNode: <GoX />,
  downloadData: <GoCloudDownload />,
  editNotes: <GoFile />,
  moveLeft: <IoMdArrowBack />,
  moveRight: <IoMdArrowForward />,
  renameNode: <GoPencil />,
  // moveLeft: <GoChevronLeft />,
  // moveRight: <GoChevronRight />,
  // moveLeft: <img src={indentLeft} alt="" />,
  // moveRight: <img src={indentRight} alt="" />,
}


export default observer(() => {

  const neomem = useNeomem()
  const { tripPlanner } = neomem.plugins

  //----------------------------------------------------------------------
  // handle menu
  //----------------------------------------------------------------------

  const [menuActions, setMenuActions] = useState([])
  const [menuOpen, setMenuOpen] = useState(false)
  const [menuPosition, setMenuPosition] = useState([0, 0])
  const [menuNodeId, setMenuNodeId] = useState(null)
  const showMenu = (e, nodeId) => {
    e.stopPropagation() // otherwise ?
    const typeId = neomem.getNodeValue(nodeId, 'typeId')
    const actionIds = typeId ? neomem.getNodeValue(typeId, 'actionIds') : ''
    const actionIdArray = actionIds ? actionIds.split(',') : []
    const menuAction = actionIdArray.map(actionId => neomem.getNode(actionId))
    // get top of span containing the menu icon - use for menu y position
    // and right of the navtree div for the menu x position
    const span = e.target.parentNode
    const { top } = span.getBoundingClientRect()
    const div = document.getElementById('nodes')
    const { right } = div.getBoundingClientRect()
    const position = [right, top]
    setMenuPosition(position)
    setMenuNodeId(nodeId)
    setMenuActions(menuAction)
    setMenuOpen(true)
  }
  const handleMenuAction = (e, nodeId, actionId) => {
    doAction(e, nodeId, actionId)
  }
  const handleMenuClose = () => setMenuOpen(false)

  //----------------------------------------------------------------------
  // handle notes
  //----------------------------------------------------------------------

  // must define state here before any possible exits
  const [notesOpen, setNotesOpen] = useState(false)
  // const toggleNotesOpen = () => setNotesOpen(notesOpen => !notesOpen)
  const showNotes = () => setNotesOpen(true)
  const handleNotesOkay = (value) => {
    neomem.setNodeValue(menuNodeId, 'notes', value)
    setNotesOpen(false)
  }
  const handleNotesCancel = () => {
    setNotesOpen(false)
  }

  //----------------------------------------------------------------------
  // get app state
  //----------------------------------------------------------------------

  if (neomem.initializing) return null
  const currentNodeId = neomem.currentNodeId //. mobx being weird, had to use this
  if (!currentNodeId) return null
  const currentNode = neomem.getNode(currentNodeId) // .name is getter/setter, as expected
  console.log('current node:', currentNodeId, currentNode)

  //----------------------------------------------------------------------
  // get list of nodes
  //----------------------------------------------------------------------

  //. note this gets called each time an element is added to the tree, eg in loading,
  // so get progressively more elements in array - bad
  //. check neomem.hydrating flag?
  const places = neomem.getTree('welcome') //.
  window.places = places //. for debug

  //----------------------------------------------------------------------
  // define actions
  //----------------------------------------------------------------------

  const doAction = (e, nodeId, actionId) => {
    // e.stopPropagation() // stop bubbling - otherwise original node gets selected again right after action
    const action = actionHandlers[actionId]
    action(nodeId)
  }

  // note: addPlace is handled by the header component

  const addTrip = () => {
    //. ask for new name
    const name = window.prompt("Enter name for new trip:", "(Unnamed trip)")
    if (name) {
      const trip = tripPlanner.addTrip({name})
      neomem.setCurrentNodeId(trip.id)  
    }
  }

  const selectNode = (nodeId) => neomem.setCurrentNodeId(nodeId)

  //. code duplicated in viewmap! move to a ui callback fn that neomem can call
  const removeNode = (nodeId) => {
    const node = neomem.getNode(nodeId)
    if (window.confirm(`Remove ${node.name} and any subitems and notes? This can't be undone!`)) {
      // first select the parent node so we don't point to a non-existent node
      const parent = neomem.getParent(nodeId)
      neomem.setCurrentNodeId(parent.id)
      setMenuNodeId(null)
      neomem.deleteNode(nodeId)
    }
  }

  // move nodes - dnd view calls this fn on drag end
  const onDragEnd = (result) => {
    if (result.destination) {
      if (result.source.index === 0 || result.destination.index === 0) {
        alert("Moving Welcome message not allowed")
        return
      }
      const [fromId, toId, movingFromAbove] = util.getMoveIds(result.source.index, result.destination.index, places)
      neomem.moveChild(fromId, toId, movingFromAbove)
    }
    // else dropped outside the list
  }

  const editNotes = (nodeId) => showNotes(nodeId)

  const renameNode = (nodeId) => {
    const oldName = neomem.getNodeValue(nodeId, 'name') || ''
    const newName = window.prompt(`Enter new name for '${oldName}':`, oldName)
    if (newName) {
      neomem.setNodeValue(nodeId, 'name', newName)
    }
  }

  const deleteNode = (nodeId) => {
    removeNode(nodeId)
  }

  const downloadData = (nodeId) => {
    const text = neomem.getTreeText(nodeId)
    fileDownload(text, 'TripPlannerData.txt')
  }

  //. move this logic into neomem with ui callback
  const moveLeft = (nodeId) => {
    const node = neomem.getNode(nodeId)
    const depth = node.depth || 0
    if (depth > 2) {
      neomem.moveLeft(nodeId)
    } else {
      alert("Can't move this item left")
    }
  }

  //. move this logic into neomem with ui callback
  const moveRight = (nodeId) => {
    const node = neomem.getNode(nodeId)
    const prevIndex = places.indexOf(node) - 1
    const prevNode = places[prevIndex]
    const depth = node.depth || 0
    if (depth <= (prevNode.depth || 0)) {
      neomem.moveRight(nodeId)
    } else {
      alert("Can't move this item right")
    }
  }


  // maps actionIds to functions (gave same name for simplicity)
  // note: this has to come AFTER all the methods defined above or they'll all be undefined!
  const actionHandlers = { addTrip, editNotes, renameNode, deleteNode, downloadData, moveLeft, moveRight }


  //----------------------------------------------------------------------
  // components
  //----------------------------------------------------------------------

  // modal notes dialog
  const NotesDialog = ({nodeId}) => {
    // if 
    return (
      <DialogText
        isOpen={notesOpen}
        title={nodeId ? ("Notes for " + neomem.getNodeValue(nodeId, 'name')) : ''}
        defaultValue={nodeId ? neomem.getNodeValue(nodeId, 'notes') || '' : ''}
        handleOkay={handleNotesOkay}
        handleCancel={handleNotesCancel}
      />
    )
  }

  // notes panel at bottom of navtree
  const NotesPanel = observer(() => (
    <>
      {currentNode && currentNode.depth > 0 &&
        <div className="nodes-notes">
          <div className="nodes-notes-header">
            <span className="nodes-notes-title">Notes</span>
            <span className="nodes-notes-buttons">
              <span className="nodes-notes-open" onClick={showNotes} title="Edit in dialog">
                <GoLinkExternal />
              </span>
            </span>
          </div>
          <div className="nodes-notes-text">
            <textarea name="notes" id="notes" defaultValue={currentNode.notes} />
          </div>
        </div>
      }
    </>
  ))

  const getNodeClass = (place, isDragging) => {
    // somehow mobx wasn't detecting ui.currentNodeId buried down in here - had to pull it out as another var up top.
    return "node" + (place.id === currentNodeId ? " selected" : "") + (isDragging ? " dragging" : "") + (place.typeId === 'trip' ? " trip" : "")
  }

  const Node = observer(({ place, index }) => {
    const typeId = neomem.getNodeValue(place.id, 'typeId')
    const typeIcon = typeId ? typeIcons[typeId] : null
    // const fixed = place.id === 'welcome'
    return (
      <Draggable key={place.id} draggableId={place.id} index={index}>
        {(provided, snapshot) => (
          <>
            {/* className could be eg 'node selected dragging' */}
            <div
              className={getNodeClass(place, snapshot.isDragging)}
              data-indent={place.depth}
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              style={provided.draggableProps.style}
              onClick={() => selectNode(place.id)}
            >
              <span className="node-icon">
                {typeIcon}
              </span>
              <span className="node-name" title={place.name}>
                {place.name}
              </span>
              <span
                className="node-menu-button"
                role="button"
                onClick={(e) => showMenu(e, place.id)}
                title="Click for menu"
              >
                <img src={iconMenu} alt="" />
              </span>
              {flags.showNotesInline && place.notes &&
                <div className="node-notes">
                  {place.notes.slice(0, 30)}
                </div>
              }
            </div>
          </>
        )}
      </Draggable>
    )
  })

  // this is a bit complex but is how you implement a draggable list.
  // basic structure is like
  // <div className="places">
  //   {places.map => <div className="place">{place.name}</div>}
  // </div>
  return (
    <div className="nodes" id="nodes">
      <div className="nodes-header">
        {/* <span className="nodes-header-title">
          Welcome
        </span> */}
        {/* <span className="nodes-header-buttons">
          <span className="nodes-header-tree" title="Show tree view">
            <GoFile />
          </span>
          <span className="nodes-header-grid" title="Show grid view">
            <GoFile />
          </span>
          <span className="nodes-header-doc" title="Show document view">
            <GoFile />
          </span>
        </span> */}
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div className="node-list" {...provided.droppableProps} ref={provided.innerRef} >
                {places && places.map((place, index) => {
                  return <Node place={place} index={index} key={place.id} data-indent={place.depth} />
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
      {flags.showNotesInNav && <NotesPanel />}
      <NotesDialog nodeId={menuNodeId} />
      <PopupMenu
        menuId="navtree-popup"
        isOpen={menuOpen}
        nodeId={menuNodeId}
        actions={menuActions}
        actionIcons={actionIcons}
        handleAction={handleMenuAction}
        handleClose={handleMenuClose}
        position={menuPosition}
      />
    </div>
  )
})
